'use client';

import { c as _c } from "react/compiler-runtime";
import { CardSliderNavButtons } from '@7f-ui/components/card-slider/card-slider';
import { useCanScroll } from '@7f-ui/hooks/use-can-scroll';
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import type { AccommodationRate } from '@data-access/graphql/schema.types';
import { useRef } from 'react';
import type { AvailableRoom } from '../../hooks/use-available-rooms';
import { RatesList } from './rates-list';
type RatesListContainerProps = {
  room: AvailableRoom;
  onSelectRate?: (rate: AccommodationRate, room: AvailableRoom) => void;
  selectedRate?: string;
  isCheapestRoom: boolean;
};
export function RatesListContainer(t0) {
  const $ = _c(26);
  let isCheapestRoom;
  let onSelectRate;
  let props;
  let room;
  if ($[0] !== t0) {
    ({
      room,
      onSelectRate,
      isCheapestRoom,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isCheapestRoom;
    $[2] = onSelectRate;
    $[3] = props;
    $[4] = room;
  } else {
    isCheapestRoom = $[1];
    onSelectRate = $[2];
    props = $[3];
    room = $[4];
  }
  const isMobile = useMediaState("mobile");
  const sliderListRef = useRef(null);
  const {
    canScrollLeft,
    canScrollRight
  } = useCanScroll(sliderListRef);
  const showNavButtons = (canScrollLeft || canScrollRight) && !isMobile;
  let t1;
  if ($[5] !== props || $[6] !== room.rates) {
    let t2;
    if ($[8] !== props) {
      t2 = rate => rate.productId === props.selectedRate;
      $[8] = props;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = room.rates.find(t2);
    $[5] = props;
    $[6] = room.rates;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const selectedRate = t1;
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-heading5">Option wählen</span>;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== room.rates.length || $[12] !== showNavButtons) {
    t3 = showNavButtons && <CardSliderNavButtons sliderListRef={sliderListRef} amountOfItems={room.rates.length} ariaLabelPrevious="vorherige Option anzeigen" ariaLabelNext={"n\xE4chste Option anzeigen"} />;
    $[11] = room.rates.length;
    $[12] = showNavButtons;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t3) {
    t4 = <div className="hidden items-center justify-between sm:flex">{t2}{t3}</div>;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== canScrollLeft || $[17] !== canScrollRight || $[18] !== isCheapestRoom || $[19] !== onSelectRate || $[20] !== room || $[21] !== selectedRate) {
    t5 = <RatesList room={room} sliderListRef={sliderListRef} canScrollRight={canScrollRight} onSelectRate={onSelectRate} selectedRate={selectedRate} canScrollLeft={canScrollLeft} isCheapestRoom={isCheapestRoom} />;
    $[16] = canScrollLeft;
    $[17] = canScrollRight;
    $[18] = isCheapestRoom;
    $[19] = onSelectRate;
    $[20] = room;
    $[21] = selectedRate;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t4 || $[24] !== t5) {
    t6 = <div className="full-bleed flex flex-col gap-2">{t4}{t5}</div>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}